
import './StudentDetails.css';

import { Link, useParams, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getEmploymentTypes, getWorkPlaces, getGenders, showLocalTime  } from '../../Javascript_Functions_to_export/Utils';

import Footer from '../Footer/Footer';

import NotFound from '../../MyComponents/NoFound/NotFound';

import detailsPic from '../../aImages/jobDetails.jpg';

import axios from 'axios';

import FileUploader from '../Uploader/FileUploader';

import parse from 'html-react-parser';

import { useNavigate } from "react-router-dom";

import useGetJobWithFullDetails from '../../CustomeHooks/useGetJobWithFullDetails';

import { useToast } from '../../CustomeHooks/useToast';

import { getUserFromCookie } from '../../Javascript_Functions_to_export/Utils';

import Cookie from 'js-cookie';

import { isValidToken } from '../../Javascript_Functions_to_export/Utils';
import { debug } from 'util';

import socket from '../../SocketConnection/Socket';


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const StudentDetails = () => {

    //const [userAllowed, setUserAllowed] = useState(true);
    
    const navigate = useNavigate();

    const toast = useToast();
    const { id } = useParams();
    
    //debugger;
    const location = useLocation();
    //console.log(location.state?.LastVisitedPage);

    const { lsData: currItem, isLoading, found } = 
    //useGetJobWithFullDetailsX('http://localhost:808x/job_full_detailsXX/' + id);
    useGetJobWithFullDetails(`${process.env.REACT_APP_URL}/job_full_details/${id}?isAdmin=` +
                             (getUserFromCookie(Cookie.get('adminToken')).ID ? true : false) + 
                             `&openedRight=` + 
                             (location.state?.LastVisitedPage.indexOf(`/search`) >= 0 ||
                              location.state?.LastVisitedPage == null ? true : false));

    const loggedInIconBase64 = "data:@file/png;base64,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"; 

    const [currentJob, setCurrentStudent] = useState(null);

    useEffect(() => {
        //console.log("item = ", currItem);
        // change the "PostedDate" of currItem, then set the final object.
        if(currItem) {

            // var arra = currItem.ApplicantsIDs.split(',');
            // console.log("arra=", arra);

            // var Id = getUserFromCookie(Cookie.get('token')).ID + '';
            // console.log("getUserFromCookie(Cookie.get('token')).ID=", Id.toString());

            // console.log("contains =", currItem.ApplicantsIDs.split(',').includes(getUserFromCookie(Cookie.get('token')).ID.toString()));


            //console.log("new Date(currItem.PostingDate) = ", new Date(currItem.PostingDate));

            // var datetimeMilli = new Date(currItem.PostingDate).getTime();
            // var d = new Date();
            // datetimeMilli += -d.getTimezoneOffset() * 60000; // 1 * timeZoneOffset 
            // var dateLocal = new Date(datetimeMilli).toLocaleString('en-US', { hour12: false });
            // dateLocal = dateLocal.slice(0, dateLocal.indexOf(","));
          
            // var monthNb = dateLocal.slice(0, dateLocal.indexOf("/"));
            // var monthSt;
            // monthNb == 1 ? monthSt = "Jan" :
            // monthNb == 2 ? monthSt = "Feb" :
            // monthNb == 3 ? monthSt = "Mar" :
            // monthNb == 4 ? monthSt = "Apr" :
            // monthNb == 5 ? monthSt = "May" :
            // monthNb == 6 ? monthSt = "Jun" :
            // monthNb == 7 ? monthSt = "Jul" :
            // monthNb == 8 ? monthSt = "Aug" :
            // monthNb == 9 ? monthSt = "Sep" : 
            // monthNb == 10 ? monthSt = "Oct" :
            // monthNb == 11 ? monthSt = "Nov" :
            // monthSt = "Dec";

            // currItem.PostingDate = monthSt + dateLocal.slice(dateLocal.indexOf("/"));
            // console.log(dateLocal);
            setCurrentStudent(showLocalTime(currItem));
        }
    }, [currItem]);
    
    const [file, setFile] = useState();

    const companyProfileAsHTML = currentJob ? 
                                 currentJob.CompanyProfile : 
                                 null;

    const [userCVAsBase64, setUserCVAsBase64] = useState('');
    const xx = (_files) => {

        //console.log("_files 1", _files);
        
        /* new code */
        if(_files && _files.length > 0) {
            setFile(_files[0]);
            
            var reader = new FileReader();
            reader.onloadend = function() {
                setUserCVAsBase64(reader.result);
            }
            reader.readAsDataURL(_files[0]);
        }
        else
            setFile(null);
    }
    

    //const [categories, setCategories] = useState();
    const [employmentTypes, setEmploymentTypes] = useState();
    const [workPlaces, setWorkPlaces] = useState();
    const [genders, setGenders] = useState();


    useEffect(() => {
        //debugger;
        // axios.get(`${process.env.REACT_APP_URL}/touch_session`)
        // .then(res => {
        //     console.log("sessionEnded=", res.data.sessionEnded, "expire=", res.data.expire);
        //     if(res.data.sessionEnded && res.data.sessionEnded === true) {
        //         console.log("should logout");
        //         alert("Session has expired.")
        //         if(localStorag.getItem('Logo'))
        //             localStorag.removeItem('Logo');
        //         window.location.href = process.env.REACT_APP_ORIGI + "/login";
        //     }
        // });

        var _token = null;
        if(Cookie.get('token'))
            _token = Cookie.get('token');
        else if(Cookie.get('adminToken'))
            _token = Cookie.get('adminToken');

        // User already has logged in, BUT the cookie has expired
        if(!_token && sessionStorage.getItem('Logo')) {
            alert("Session has expired, please Login again");
            sessionStorage.removeItem('Logo');
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            return;
        }

        // User has changed or added the token by hand
        if(_token && !isValidToken(_token)) {
            return;
        }

        

        // initialize all Dummy values (Just like 'Othman Fayed in <<WPF>>')
        //setCategories(getJobCategories());
        setEmploymentTypes(getEmploymentTypes());
        setWorkPlaces(getWorkPlaces());
        setGenders(getGenders());
        
        socket.emit("pageVisit", 
            { 
                page: `job/details/${id}`, 
                isLoggedIn: Cookie.get('token') ? true : false,
                username: Cookie.get('token') ? getUserFromCookie(Cookie.get('token')).Username : null,
            });

        window.scrollTo(0, 0);
        //console.log('cat = ');

    }, []);

    axios.defaults.withCredentials = true;

    const apply = () => {
        
        var _token = null;
        if(Cookie.get('token'))
            _token = Cookie.get('token');
        else if(Cookie.get('adminToken'))
            _token = Cookie.get('adminToken');

        // User already has logged in, BUT the cookie has expired
        if(!_token && sessionStorage.getItem('Logo')) {
            alert("Session has expired, please Login again");
            sessionStorage.removeItem('Logo');
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            return;
        }

        // User has changed or added the token by hand
        if(_token && !isValidToken(_token)) {
            return;
        }

        // If user is not logged in, Prevent him to apply and redirect him to the Login page
        
        if(!_token && !sessionStorage.getItem('Logo')) {
            toast('warning', 'Please Login to Apply !');
            navigate('/login', { state: { LastVisitedPage: "/job/details/" + id } });   // Line added on 28/Feb/2026
            return;
        }

        if(getUserFromCookie(Cookie.get('token')).AccountType === 1) {   // Employer=1, Candidate=0
            toast('warning', 'Employers cannot apply for a job !');
            return;
        }

        var userID = getUserFromCookie(Cookie.get('token')).ID;
        

        if(currentJob.ApplicantsIDs) {
            var applicantsIDs = currentJob.ApplicantsIDs.split(',');
            
            if(applicantsIDs.includes(userID.toString())) {
                toast("warning", "Already applied for this job!");
                return;
            }
        }

        // If there is no CV, Prevent user to applies
        if(!file || file.length === 0) {
            toast("warning", "You didn't attach your CV !");
            return;
        }
    
        setIsApplyingJob(true);
        var formData = {}; //new FormData();
        //formData.append("jobID", id);
        formData.userID = userID;
        formData.companyEmail = currentJob.Email;
        
        if(userCVAsBase64) { // if user click on "Apply" accidentally before he selects its CV.
            //formData.append("file", file);   //  old code
            formData.userCV = userCVAsBase64;
            formData.fileName = file.name; 
        }
        formData.EmailSubject = currentJob.EmailSubject;
        formData.EmailBody = currentJob.EmailBody;
        formData.JobTitle = currentJob.JobTitle;
        formData.CompanyName = currentJob.CompanyName;

        // Information to update the "Applicants Nb"
        formData.ApplicantsNb = currentJob.ApplicantsNb;
        formData.CompanyId = currentJob.JobID;
        formData.ApplicantsIDs = currentJob.ApplicantsIDs;
        
        // step 1/ send email to desired company
        //axios.post('http://localhost:808x/apply_and_send_email', formData)

        axios.post(`${process.env.REACT_APP_URL}/apply_and_send_email`, formData)
       .then((res) => {

            // console.log("sessionEnded=", res.data.sessionEnded, "expire=", res.data.expire);
            // if(res.data.sessionEnded && res.data.sessionEnded === true) {
            //     console.log("should logout");
            //     alert("Session has expired.")
            //     if(localStorag.getItem('Logo'))
            //         localStorag.removeItem('Logo');
            //     window.location.href = process.env.REACT_APP_ORIGI + "/login";
            // }
            if(res.data.status) { 
                if(res.data.status === 'success') {
                    navigate('/sent_successfully', { state: { LastVisitedPage: "job/details/" + id } });
                }
                else {
                    if(res.data.message && res.data.message === "Sent with error in DB!") {
                        toast("success", "Application sent successfully !");
                        toast("warning", "Internal error, please do not apply again !");
                        navigate('/sent_successfully', { state: { LastVisitedPage: "job/details/" + id } });
                    }
                    else
                        toast("error", res.data.message ? res.data.message : "Unexpected error !");
                }
            }
            else if(res.data && res.data === 'failed') {
                toast('error', "Error in sending application !");
            }
        })
        .catch(err => {
            console.log("err", err);
        })
        .finally(() => {
            setIsApplyingJob(false);
        });

        

        //debugger;
        //var fileURL = file.URL;      // "https://cdn.sstatic.net/clc/img/jobs/bg-remote-header-sm.png";
        //var fileName = '';

        //if(file.type === 'application/pdf') {   //     Additional File (2MB max): (.zip,.doc,.docx,.pdf,.txt)
        //    fileName = "CV.pdf";
        //} else {
        //    fileName = "CV.docx";
        //}

        // use formData = new FormData() instead of these 3 lines
        // var applicationToSend = {
        //     companyEmail : currentJob.Email,
        //     filePath_AsAtt: 'C:/Users/user/Downloads/' + fileName
        // }
    
        //return;

        /*//fetch('http://localhost:808x/sendemail', {
        fetch('http://localhost:808x/post_a_job', { 
            method: "POST",
            mode: "cors",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)  // it was newAirplane in "AviMall.com"
        })
        .then(() => {
            //if(res.data.Status === 'success')
                //toast("Your application has been sent successfuly");
            //else
                //toast("There was an error while sending your application.");
        })
        .catch(e => {

        })*/
    }
    
    const [isAddingCV, setIsAddingCV] = useState(false);
    const [isApplyingJob, setIsApplyingJob] = useState(false);

    const getIsAddingCV = (_isAdding) => {
        //console.log("adding = ", _isAdding);
        setIsAddingCV(_isAdding);
    }

    const backward = () => {
        // new block
        //console.log("local=",localStorage.getItem('search'));
        if(localStorage.getItem('search')) {
            navigate('/search' + localStorage.getItem('search'), { state: { LastVisitedPage: "job/details/" + id } });
        }
        else {
            navigate('/search', { state: { LastVisitedPage: "job/details/" + id } });
        }

        return;

        // old code
        //navigate(-1);
        window.history.back();
    } 
    
    const settings = {
        dots: true,         // show navigation dots
        infinite: true,     // loop slides
        speed: 500,         // transition speed
        slidesToShow: 1,    // number of slides to show
        slidesToScroll: 1,  // slides to scroll at a time
        autoplay: true,     // auto-slide
        arrows: false,      // hide next/prev arrows
        autoplaySpeed: 3000 // 3 seconds per slide
    };

    const imageHeight = 400; // Set the height of the image


    //if(!currentJob && !isLoading) 
     if(found === -1) 
         return (
  
             <NotFound />
         )

    if(isLoading) {
        return(
            <div id='details-loading-message' style={{ marginRight: 'auto', 
                          marginLeft: 'auto', 
                          position: 'relative', 
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                          //top: '50%',
                          height: '100vh',
                          width: 'fit-content',
                        //   border: 'solid 1px red',
                          fontSize: '25px',
                          color: '#c1c1c1' }}>
                    Loading Details ...
            </div>
        )
    }
    
    if(currentJob)
    return(

        <div className='every-page-container'>
{/*             
            {
                currentJob ? 
                <span style={{ color: 'white' }}>fi object</span> :
                <span style={{ color: 'white' }}>ma fi object</span>
            } */}

            <div className='apply-job-container' >
                { 
                    isLoading ? 
                    'Loading please wait ...' :  
                    
                    !currentJob ? 
                    <div>
                        <NotFound />
                    </div> :

                    <>
                        <div className='slider-container'>
                            <Slider {...settings}>
                                {/* <div className='ad-item'>
                                    <img
                                        src="https://sgskr.mjt.lu/img2/sgskr/e2102ecc-7112-4f72-bbd6-1a4213de7f58/content"
                                        alt="Ad1"
                                    />
                                </div> */}

                                {/* <div className='ad-item'>
                                    <img
                                        src="https://sgskr.mjt.lu/img2/sgskr/cf088717-0835-48f6-9ee8-676555fd5e6b/content"
                                        alt="Ad2"
                                    />
                                </div> */}

                                <div className='ad-item'>
                                    <img
                                        src="https://sgskr.mjt.lu/img2/sgskr/a2f6505c-3005-455c-9783-4fe47aa8d76d/content"
                                        alt="Ad2"
                                    />
                                </div>

                                

                                {/* <div className='ad-item'>
                                    <img
                                            src="https://sgskr.mjt.lu/img2/sgskr/720e93c2-12f7-40b6-b7b9-7bbb4c6906df/content"
                                            alt="Ad3"
                                        />
                                </div> */}
                            </Slider>
                        </div>

                        {/* <div className='big-picture'>
                            <img src={ detailsPic } 
                                alt="details" 
                                className='big-pic' />
                        </div>

                        <div className='line1 contain-company-logo'>
                                <div className='col1'>

                                    {
                                        currentJob.IsConfidential || currentJob.IsConfidential == 1 ? 
                                        <i className="fa fa-shield company-pic" 
                                            aria-hidden="true" 
                                            style={{ fontSize: '122px', marginTop: '-4px' }}></i>
                                        :
                                        currentJob.Logo !== loggedInIconBase64 ?
                                        // <img src={ "/" + currentJob.Logo } 
                                        <img src={ currentJob.Logo } 
                                            alt="Company Logo" 
                                            className='company-pic' />
                                        :
                                        <i className="fa fa-picture-o" 
                                            aria-hidden="true"
                                            style={{ fontSize: '125px', opacity: '0.2'}}>
                                        </i>

                                    }
                                </div>
                                
                                <div className='col2' style={{ display: 'none' }}>
                                    {
                                        Cookie.get('token') &&
                                        currentJob.ApplicantsIDs &&
                                        currentJob.ApplicantsIDs.split(',').includes(getUserFromCookie(Cookie.get('token')).ID.toString()) ?
                                        <button className='applied-btn'> 
                                            Applied
                                        </button>
                                        :

                                        <button name='applyjob_2'
                                                type='button'
                                                onClick={ apply }
                                                className={`apply-btn ${ isApplyingJob === true || isAddingCV === true ? 'disabled' : ''}`}
                                                // value={`${ isApplyingJob || isAddingCV ? 'Posting' : 'Post'}`} 
                                                disabled={ isApplyingJob === true || isAddingCV === true }>
                                                { 
                                                    isAddingCV === true ? 'Apply' :
                                                    isApplyingJob === true ? 'Applying' : 
                                                    'Apply'
                                                } 
                                        </button>
                                    }
                                </div>
                        </div> */}

                        

                        <div className='job-summary'>
                            
                            {/* <div className='line1'> ... </div>   has been moved outside*/}

                            <div className='title-line1'>
                                <div>
                                    { currentJob && currentJob.JobTitle }
                                </div>
                                <div className='div-back-button'>
                                    <button name='backButton'
                                            className='back-btn'
                                            type='button'
                                            onClick={ backward } >
                                        <u>
                                            Back To List
                                        </u>
                                    </button> 
                                </div>
                                <div className='div-back-button-mobile'>

                                    <svg xmlns="http://www.w3.org/2000/svg"
                                         width="25" 
                                         height="25" 
                                         onClick={ backward }
                                         viewBox="0 0 512 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"/></svg>

                                    {/* <i className="fa fa-arrow-circle-left" 
                                       aria-hidden="true"
                                       onClick={ backward }></i> */}
                                    {/* <span>Details</span> */}
                                </div>

                            </div>

                            <div className='location-line2'>
                                Company : { 
                                    currentJob && currentJob.IsConfidential === 1 ? 
                                    'Confidential' : 
                                    currentJob && currentJob.CompanyName
                                } 
                            </div>

                        </div>

                        <div className='job-details'>
                            <div className='col1'>
                                <div className='job-information-text'>Job Information</div>
                                    <JobInformationDetail icon=<i className="fa fa-calendar" aria-hidden="true"></i>
                                                        text='Posted Date' 
                                                        value={ currentJob && currentJob.PostingDate } />

                                    <JobInformationDetail icon=<i className="fa fa-map-marker" aria-hidden="true"></i> 
                                                        text='Location' 
                                                        value=
                                                        { 
                                                            // currentJob && currentJob.Location 
                                                            currentJob.Location === 'null' ||
                                                            currentJob.Location === null ||
                                                            currentJob.Location.trim() === '' ?
                                                            'Not specified' :
                                                            currentJob.Location
                                                        } />
                                                        
                                    <JobInformationDetail icon=<i className="fa fa-venus-mars" aria-hidden="true"></i>
                                                    text='Gender' 
                                                    value={ 
                                                            genders && currentJob && 
                                                            genders.find(g => g.Id === currentJob.Gender) ? 
                                                            genders.find(g => g.Id === currentJob.Gender).Name :
                                                            <span className='unknown-val'>Unknown</span> 
                                                                } />
                                    <JobInformationDetail icon=<i className="fa fa-money" aria-hidden="true"></i>
                                                    text='Salary' 
                                                    value={ currentJob && 
                                                        ( currentJob.Salary === 'null' || 
                                                            currentJob.Salary === null || 
                                                            currentJob.Salary.trim() === '' )? 
                                                        'Not Specified' : 
                                                        currentJob && currentJob.Salary } />

                                    <JobInformationDetail icon=<i className="fa fa-pencil-square-o" aria-hidden="true"></i> 
                                                    text='Type' 
                                                    value={ 
                                                        employmentTypes && currentJob && 
                                                        employmentTypes.find(g => g.Id === currentJob.EmploymentType) ? 
                                                        employmentTypes.find(g => g.Id === currentJob.EmploymentType).Name :
                                                        <span className='unknown-val'>Unknown</span> 
                                                    } />

                                    <JobInformationDetail icon=<i className="fa fa-sitemap" aria-hidden="true"></i>
                                                    text='Workplace' 
                                                    value={ 
                                                        workPlaces && currentJob && 
                                                        workPlaces.find(g => g.Id === currentJob.Workplace) ?
                                                        workPlaces.find(g => g.Id === currentJob.Workplace).Name : 
                                                        <span className='unknown-val'>Unknown</span> 
                                                    } />
                            </div>


                            <div className='col2'>

                                <div className="job-description-section">
                                    <div className='section-title'>Job Description</div>
                                    {/* <div className='details' 
                                         dangerouslySetInnerHTML={{ __html: currentJob && currentJob.JobDescription.replace("background-color", "backgroundColor") }} /> */}
                                    
                                    {/* https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_text/Wrapping_breaking_text */}
                                    <div style={{ wordBreak: 'break-word' }}>
                                    { 
                                        currentJob && 
                                        currentJob.JobDescription && 
                                        parse(currentJob.JobDescription) 
                                    }
                                    </div>
                                </div>

                                <div className="company-profile">
                                    <div className='section-title'>Company Profile</div>
                                    {/* <div className='details' dangerouslySetInnerHTML={{ __html: companyProfileAsHTML }} /> */}
                                    <div>
                                    { 
                                        currentJob &&
                                        currentJob.Profile && 
                                        parse(currentJob.Profile) 
                                        // typeof (currentJob.Profile)
                                    }
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='upload-line'>

                            <FileUploader XXX={xx} 
                                        isAddingFn={ getIsAddingCV }
                                        disableFromParent= { isApplyingJob }
                                        btnText = "Attach CV"
                                        _accept=".zip, .pdf, .docx, .doc" />
                            
                            <div className='apply-col2'>
                                {
                                    Cookie.get('token') &&
                                    currentJob.ApplicantsIDs &&
                                    currentJob.ApplicantsIDs.split(',').includes(getUserFromCookie(Cookie.get('token')).ID.toString()) ?
                                    <button className='applied-btn'> 
                                        Applied
                                    </button>
                                    :


                                    <button name='applyjob_2'
                                                type='button' 
                                                onClick={ apply }
                                                className={`apply-btn ${ isApplyingJob === true || isAddingCV === true ? 'disabled' : ''}`}
                                                // value={`${ isApplyingJob || isAddingCV ? 'Posting' : 'Post'}`} 
                                                disabled={ isApplyingJob === true || isAddingCV === true }>
                                                { 
                                                    isAddingCV === true ? 'Apply' :
                                                    isApplyingJob === true ? 'Applying' : 
                                                    'Apply'
                                                } 
                                    </button>
                                }
                            </div>
                        </div>
                    
                    </>
                }
            </div>

            <br/><br/>
            <hr className='hor-line' style={{ marginRight: 'auto', marginLeft: 'auto',  }} width='80%' />
            <div style={{ color: 'rgb(165 161 161)',
                        marginLeft: '10%',
                        marginTop: '18px',
                        marginBottom: '18px' }}>
                Copyright © { new Date().getFullYear() } All rights reserved.
            </div>
        </div>
    );
}


export default StudentDetails;


const JobInformationDetail = ({ icon, text, value}) => {

    return(
        <div className='single-info-container'>

            <div className='icon'>
                { icon }
            </div>

            <div className='textes'>
                <div className='title'>{ text }</div>
                <div className='value'>{ value }</div>
            </div>

        </div>
    )

}